import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ClickTooltipModule } from '@app/shared/ux/click-tooltip/click-tooltip.module';
import { PagingModule } from '@app/shared/ux/paging/paging.module';
import { PanelButtonComponent } from '@app/shared/ux/panel-button/panel-button.component';
import { PanelButtonModule } from '@app/shared/ux/panel-button/panel-button.module';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { CarouselModule } from 'outshared-lib';
import { ListModule } from './lists/list.module';
import { MoreIndicatorModule } from './more-indicator/more-indicator.module';
import { PanelExpandableModule } from './panel-expandable/panel-expandable.module';
import { TableCompareModule } from './table/table-compare.module';
import { TabsetModule } from './tabs/tabset.module';
/**
 *
 *
 * @export AccordionComponent
 * @export PanelExpandableComponent
 * @export TableCompareComponent
 * @export TabComponent
 * @export CarouselModule
 * @class UxModule
 */
import { VideoModule } from './video/video.module';

@NgModule({
    imports: [
        CommonModule,
        LazyLoadImageModule,
        PanelExpandableModule,
        VideoModule,
        TabsetModule,
        ClickTooltipModule,
        PagingModule,
        ListModule,
        TableCompareModule,
        PanelButtonModule,
    ],
    exports: [
        PanelExpandableModule,
        PanelButtonComponent,
        PagingModule,
        CarouselModule,
        MoreIndicatorModule,
        VideoModule,
        TabsetModule,
        ListModule,
        ClickTooltipModule,
        TableCompareModule,
    ],
})

/** @deprecated use the individual component modules from src/app/shared/ux folder */
export class UxModule {
}
